import { Timestamp } from 'firebase/firestore';

export type RoleType = 'owner' | 'admin' | 'member';

export interface Roles {
  member: string[];
  owner: string[];
}

export interface Organization {
  id: string;
  randomField: string;
  displayName: string;
  roles: Roles;
  seats: number;
}

export interface Organisation {
  id: string;
  admins: string[];
  members: string[];
  name: string;
  seats: number;
  promoCode: string;
  createdAt: Timestamp;
}
export enum csvContent {
  admins = 'admins',
  members = 'members'
}

export type CustomUserData = {
  id: string;
  uid: string;
  name: string;
  email: string;
  createdAt: Timestamp;
};

export interface UserOrganisationsRoles {
  isSuperAdmin: boolean;
  adminIn: Organisation[];
  memberIn: Organisation[];
}

// **

export type VoucherType = 'license' | 'stripe';

export interface Voucher {
  code: string;
  type: VoucherType;
  organizationUid: string;
  stripeDetails?: StripeVoucher;
}

export interface StripeVoucher {}

export interface UserInfo {
  uid: string;
  activeReflectionDay: number;
  createdAt: Timestamp;
  favourites: string[];
  personalInfo: PersonalInfo;
  gamification: GamificationInfo;
  history: History;
  lastLoginWeek: number;
  introductionStarts: Timestamp;
  introductionExpires: Timestamp;
  activeDayWhenSubscribing: number;
  reflection: SavedReflection;
  onboardingFinished: boolean;
  notes: Note[];
  pushtokens?: { [key: string]: pushToken };
  canBeNotified: boolean;
  mycorner?: { [key: string]: string };
  nextNotificationAllowed?: Date;
  subscriptionChecked?: number;
  subscriptionId?: string;
  appleSubscription?: AppleSubscription;
  googleSubscription?: GoogleSubscription;
  shownotice: string[];
  developerAccount?: boolean;
  isContentEditor?: boolean;
  isReviewingContent?: boolean;
  failedPayment?: boolean;
  externalContentProvider?: string;
  shownPopup?: number;
}
export interface AppleSubscription {
  expiration_date: string;
  original_purchase_date: string;
  subscriptionId: string;
  renewal_subscription_id: string;
  validSubscription: boolean;
  original_transaction_id: string;
  validated: boolean;
}

export interface GoogleSubscription {
  expiration_date: string;
  purchase_token: string;
  order_id: string;
  subscriptionId: string;
  transaction_date: string;
  transaction_id: string;
  validSubscription: boolean;
  package_name: string;
  validated: boolean;
}
export interface pushToken {
  date: Date;
  token: string;
  deviceId: string;
  notify: boolean;
}
export interface PersonalInfo {
  name: string;
  email: string;
  language: string;
  phone?: string;
  timeZone?: string;
}

export interface SavedReflection {
  savedReflectionTo: string;
  savedReflectionFrom: string;
  savedReflectionTimeout: number;
  lastMorningReflection?: Timestamp;
  lastEveningReflection?: Timestamp;
}

export interface GamificationInfo {
  nrOfCoins: number;
  nrOfKeys: number;
  nrOfDays: number;
  treasureFetched: boolean;
  lastDayReset?: number;
}

export interface History {
  infopages: string[];
  treasures: string[];
  mycorner: string[];
}

export interface Note {
  infopage: string;
  note: string;
}

export type UserOrganisationsByEmail = {
  orgName: string;
  orgId: string;
}[];
/* export enum SubscriptionType {
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  STRIPE = 'STRIPE',
  NONE = 'NONE'
} */

export type SubscriptionType = 'GOOGLE' | 'APPLE' | CustomerSubscription | null;
export type CustomTableUsers = {
  uid: string;
  email: string;
  name: string;
  createdAt: number;
  latestReflection: number;
  nrOfCoins: number;
  subscription: SubscriptionType;
  treasures: number;
  organisations: UserOrganisationsByEmail;
};
export const UserTableHeadersText: Record<keyof CustomTableUsers, string> = {
  uid: 'ID',
  email: 'E-postadress',
  name: 'Användarnamn',
  createdAt: 'Kontot skapades',
  latestReflection: 'Senaste slussen',
  nrOfCoins: 'Antal poäng',
  subscription: 'Prenumeration',
  treasures: 'Antal skattkistor',
  organisations: 'Organisation'
} as const;

export enum UserTableHeaders {
  uid = 'uid',
  email = 'email',
  name = 'name',
  createdAt = 'createdAt',
  latestReflection = 'latestReflection',
  nrOfCoins = 'nrOfCoins',
  subscription = 'subscription',
  treasures = 'treasures',
  organisations = 'organisations'
}

export type FieldQueryType = {
  email: string;
  name: string;
  createdAtStart: Date | undefined;
  createdAtEnd: Date | undefined;
  latestReflectionStart: Date | undefined;
  latestReflectionEnd: Date | undefined;
  nrOfCoins: string;
  subscription: string;
  treasures: string;
  organisations: string;
};

export type Subscription = {
  cancel_at: Timestamp | null;
  cancel_at_period_end: Timestamp | null;
  canceled_at: Timestamp | null;
  created: Timestamp | null;
  current_period_end: Timestamp | null;
  current_period_start: Timestamp | null;
  ended_at: Timestamp | null;
  items: any;
  metadata: any;
  price: any;
  prices: any;
  product: any;
  quantity: any;
  role: any;
  status: any;
  stripeLink: string;
  trial_end: Timestamp;
  trial_start: Timestamp;
};
export type CustomerSubscription = {
  email: string;
  stripeId: string;
  stripeLink: string;
  subscriptions: Subscription[];
};
